import React from 'react';
import { Collapse } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

export const CollapseIconCustom = ({ isActive }) => {
  return (
    <div className={`CollapseIconCustom-arrow ${(isActive) ? 'active' : ''}`}>
      <DownOutlined />
    </div>
  );
};

CollapseIconCustom.propTypes = {
  isActive: PropTypes.bool,
};

const DropdownProductFeatures = ({ title='Sobre o produto', items }) => {
  return (
    <>
      <header className="DropdownProductFeatures-header">
        <h4 className="DropdownProductFeatures-title">
          { title }
        </h4>
      </header>
      <section className="DropdownProductFeatures">
        <Collapse
          collapsible="header"
          bordered={false}
          ghost={true}
          expandIconPosition="end"
          expandIcon={CollapseIconCustom}
          items={items}
        />
      </section>
    </>
  );
};

DropdownProductFeatures.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
};

export default DropdownProductFeatures;
